/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-service.ts
 *
 * Created by randysorensen on 2/20/18.
 */

angular.module('prism-ui.package').service('PackageService', function (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,

    ContentResourceFactory: JS5Object,
    PackageResourceFactory: JS5Object
) {
    this.getCompletedDeliveries = (packageObject: JS5Object, excludePreDeliveries: boolean) => {
        return PackageResourceFactory.completedDeliveries({
            id: packageObject.id,
            excludePreDeliveries: excludePreDeliveries
        }).$promise;
    };

    this.remoteCheckIn = (remotePath: string, waitForIngest: boolean = true) => {
        return PackageResourceFactory.checkIn({
            path: remotePath,
            waitForIngest
        }).$promise;
    };

    const getTerritories = (partnerValues: JS5Object[]) => {
        return _.flatMap(partnerValues, (partnerValue: JS5Object) => {
            return [partnerValue.territory];
        });
    };

});
